ReportsService.$inject = ['$resource', 'StoresService'];

function ReportsService($resource, StoresService) {
    const Reports = $resource('api/reports/:storeId/:week/:reportType/:isToken');

    this.getReport = getReport;

    function getReport(weekStartDate, reportType, isToken) {
        let week = new Date(weekStartDate);
        week.setHours(12);  //hack for Chrome 46 date issue.  Make sure we are not going back a day in DST by forcing to midday.

        return StoresService.getStore().then(store => {
            return Reports.query({
                storeId: store.storeId,
                week: week.toISOString().slice(0, 10),
                reportType: reportType,
                isToken: isToken
            }).$promise;
        });
    }
}

export default ReportsService;



// WEBPACK FOOTER //
// ./src/js/services/reports/index.js